import { css } from '@inter-ikea-kompis/web-component';
import FocusOutlineStyleTypeEnum from '../../enums/FocusOutlineStyleTypeEnum.js';
export default class FocusOutlineStyle {
    /**
     * Returns styles.
     *
     * @param options Options object.
     * @param options.theme Theme.
     * @param options.hasFocus Has focus.
     * @param options.invertedColors Inverted colors.
     * @param options.styleType Inline or block.
     * @returns Styles.
     */
    static getStyle(options) {
        const { motion, focusOutline, color } = options.theme;
        return css `
			:host {
				outline: none;
				display: ${options.styleType === FocusOutlineStyleTypeEnum.block
            ? 'inline-block'
            : 'inline'};
				border-radius: ${focusOutline.borderRadius / 16}rem;
				position: relative;
			}

			.outlineContainer {
				position: absolute;
				z-index: inherit;
				border-radius: inherit;
				pointer-events: none;
				left: ${options.hasFocus ? '0' : '-10000px'};
				top: ${options.hasFocus ? '0' : '-10000px'};
				right: ${options.hasFocus ? '0' : 'auto'};
				bottom: ${options.hasFocus ? '0' : 'auto'};
			}

			.outline {
				position: absolute;
				z-index: inherit;
				transition-property: ${options.hasFocus ? 'opacity' : 'none'};
				transition-duration: ${motion.duration.large};
				transition-timing-function: ${motion.ease.easy};
				border-radius: inherit;
				box-shadow:
					0 0 0 ${focusOutline.offset / 16}rem
						${options.invertedColors ? focusOutline.color : color.border.inverse},
					0 0 0 ${(focusOutline.width + focusOutline.offset) / 16}rem
						${options.invertedColors ? color.border.inverse : focusOutline.color};
				left: 0;
				top: 0;
				right: 0;
				bottom: 0;
				opacity: ${options.hasFocus ? 1 : 0};
			}

			${this.getInlineStyle(options) ?? ''}
		`;
    }
    /**
     * @param options Options.
     * @param options.styleType StyleType.
     * @param options.hasFocus ...
     */
    static getInlineStyle(options) {
        const { focusOutline, motion } = options.theme;
        if (options.styleType === FocusOutlineStyleTypeEnum.inline) {
            return css `
				slot {
					transition-property: outline-color, outline-offset;
					transition-duration: ${motion.duration.large};
					transition-timing-function: ${motion.ease.easy};
					outline-width: ${focusOutline.width / 16}rem;
					outline-style: solid;
					display: inline;
					border-radius: inherit;
					${this.getInlineFocusStyle(options)}
				}
			`;
        }
        return null;
    }
    static getInlineFocusStyle(options) {
        const { color, focusOutline } = options.theme;
        if (options.hasFocus) {
            return css `
				outline-offset: ${focusOutline.offset / 16}rem;
				outline-color: ${options.invertedColors ? color.border.inverse : focusOutline.color};
			`;
        }
        return css `
			transition-property: none;
			outline-color: transparent;
			outline-offset: 0rem;
		`;
    }
}
//# sourceMappingURL=FocusOutlineStyle.js.map